import React from 'react';
import { TabelaPlanejamento } from '../../components/TabelaPlanejamento';
import MenuMain from '../../MenuMain';
import { AppFooter } from '../../AppFooter';

export default function PlanejamentoPage() {
  return (
    <div className="p-pt-0">
      <MenuMain >
       <TabelaPlanejamento />
      </MenuMain>
      <AppFooter />
    </div>
  );
}